import { MenuItem, MenuItemProps, useColorModeValue } from '@chakra-ui/react';
import { isRequestDrawerEnabledForTenant, RequestDrawers } from '@pelicargo/tenants';
import { forwardRef } from 'react';

export const EmailListMenuItem = forwardRef<HTMLElement, MenuItemProps & { drawer: RequestDrawers }>(
  ({ drawer, children, ...rest }, ref) => {
    const menuItemHoverBg = useColorModeValue('gray.100', 'whiteAlpha.100');
    if (!isRequestDrawerEnabledForTenant(drawer)) return null;

    return (
      <MenuItem _hover={{ bg: menuItemHoverBg }} {...rest} ref={ref}>
        {children}
      </MenuItem>
    );
  },
);
